export const countObjectKeys = (object: object) => Object.keys(object).length;
